export enum SurveyType {
  chat = 'chat',
  call = 'call'
}
export interface Survey {
  type: SurveyType;
  isAgreed: boolean;
  recommendationScale: number;
  recommendationComment: string;
  continueSupportService: number;
  supportServiceComment: string;
  supportServiceRating: number;
  faqViewStatus: string;
  faqHelpfulnessScale: number;
  faqUnhelpfulnessReasons: string[];
  faqUnhelpfulnessOtherReason: string;
  supportHelpfulnessScale: number;
  supportUnhelpfulnessReason: string;
  supportUnhelpfulnessOtherReason: string;
  enquiryRating: number;
  operatorRating: number;
  hasBeenResolved: boolean;
  age: string;
  literacy: string;
  gender: string;
  deviceSupportNeeds: string;
  deviceSupportFeedbackRequest: string;
}
export interface PageInfo {
  isNextButtonDisabled: boolean;
  pageName: string;
 }
